<template>
    <div>
	<base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-12 col-xl-10 m-auto">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                            <h3 class="mb-0">ตรวจสอบข้อมูล</h3>
                            </div>
                        </div>
                    </div>
                    <template>
                        <h6 class="heading-small text-muted mb-3">ข้อมูลทั่วไป</h6>
                        <div class="row">
                            <div class="col-lg-6">
                                <label>คำนำหน้า : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4 class="card-text"> {{name_title}} </h4>
                                </div>
                                <div class="form-group" v-else>
                                    <v-select 
                                        :class="[ { 'is-invalid bd-danger': submit && $v.name_title.$error } , 'w-100' ]"
                                        label="nameTitle"
                                        :options="ListNameTitle"
                                        v-model="name_title"
                                    ></v-select>
                                    <!-- vuelidate -->
                                    <label
                                        v-if="submit && !$v.name_title.required"
                                        class="invalid-feedback d-block"
                                    >กรุณาเลือกคำนำหน้า</label>
                                </div>
                            </div>
                             <div class="col-lg-6">
                                <label>ชื่อ-นามสกุล : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{name}} </h4>
                                </div>
                                <div class="form-group" v-else>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': submit && $v.name.$error }"
                                        placeholder="ชื่อ-นามสกุล"
                                        v-model="name"
                                    />
                                    <!-- vuelidate -->
                                    <label
                                        class="error invalid-feedback"
                                        v-if="!$v.name.minLength"
                                    >กรุณากรอก"ชื่อ-นามสกุล"อย่างน้อย {{$v.name.$params.minLength.min}} ตัวอักษร</label>
                                    <label
                                        v-if="submit && !$v.name.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกชื่อ-นามสกุล</label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <label v-if="customer_type == 'person'">เลขบัตรประชาชน : </label> 
                                <label v-else>เลขประจำตัวผู้เสียภาษี : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{tax_id}} </h4>
                                </div>
                                <div class="form-group" v-else>
                                    <input
                                        type="number"
                                        class="form-control"
                                        :class="{ 'is-invalid': submit && $v.tax_id.$error }"
                                        placeholder="เลขบัตรประชาชน"
                                        v-model="tax_id"
                                    />
                                    <!-- vuelidate -->
                                    <label
                                        class="error invalid-feedback"
                                        v-if="!$v.tax_id.minLength"
                                    >กรุณากรอก"เลขบัตรประชาชน"อย่างน้อย {{$v.tax_id.$params.minLength.min}} ตัวเลข</label>
                                    <label
                                        class="error invalid-feedback"
                                        v-if="!$v.tax_id.maxLength"
                                    >กรุณากรอก"เลขบัตรประชาชน"ไม่เกิน {{$v.tax_id.$params.maxLength.max}} ตัวเลข</label>
                                    <label
                                        v-if="submit && !$v.tax_id.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกเลขบัตรประชาชน</label>
                                </div>
                            </div>
                            <div class="col-lg-6" v-if="customer_type == 'person'">
                                <label>วันเกิด : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{date_birthday}} </h4>
                                </div>
                                <div class="form-group" v-else>
                                    <input
                                        type="date"
                                        class="form-control"
                                        :class="{ 'is-invalid': submit && $v.date_birthday.$error }"
                                        placeholder="วันเกิด"
                                        v-model="date_birthday"
                                    />
                                    <!-- vuelidate -->
                                    <label
                                        v-if="submit && !$v.date_birthday.required"
                                        class="invalid-feedback"
                                    >กรุณาเลือกวันเกิด</label>
                                </div>
                            </div>
                             <div class="col-lg-6" v-if="customer_type == 'person'">
                                <label>วันที่บัตรหมดอายุ : </label>
                                <div v-if="isSuperadmin()">
                                    <h4> {{date_expiry}} </h4>
                                </div> 
                                <div class="form-group" v-else>
                                    <input
                                        type="date"
                                        class="form-control"
                                        :class="{ 'is-invalid': submit && $v.date_expiry.$error }"
                                        placeholder="วันที่บัตรหมดอายุ"
                                        v-model="date_expiry"
                                    />
                                    <!-- vuelidate -->
                                    <label
                                        v-if="submit && !$v.date_expiry.required"
                                        class="invalid-feedback"
                                    >กรุณาเลือกวันที่บัตรหมดอายุ</label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <label>เบอร์โทรศัพท์ : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{tel}} </h4>
                                </div>
                                <div class="form-group" v-else>
                                    <input
                                        type="number"
                                        class="form-control"
                                        :class="{ 'is-invalid': submit && $v.tel.$error }"
                                        placeholder="เบอร์โทรศัพท์"
                                        v-model="tel"
                                    />
                                    <!-- vuelidate -->
                                    <label
                                        v-if="submit && !$v.tel.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกเบอร์โทรศัพท์</label>
                                    <label
                                        class="error invalid-feedback"
                                        v-if="!$v.tel.minLength"
                                    >กรุณากรอก"เบอร์โทรศัพท์"อย่างน้อย {{$v.tel.$params.minLength.min}}ตัวเลข</label>
                                </div>
                            </div>
                             <div class="col-lg-6">
                                <label>Email : <small class="text-muted">(ใช้สำหรับ แจ้งสลิปการโอนเงิน)</small></label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{email}} </h4>
                                </div>
                                <div class="form-group" v-else>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        :class="{ 'is-invalid': submit && $v.email.$error }"
                                        placeholder="Email"
                                        v-model="email"
                                    />
                                    <!-- vuelidate -->
                                    <label
                                        v-if="submit && !$v.email.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกอีเมล์</label>
                                    <label
                                        v-if="submit && !$v.email.email"
                                        class="invalid-feedback"
                                    >รูปแบบอีเมล์ไม่ถูกต้อง</label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <label>ที่อยู่ (ตามบัตรประชาชน) : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{address}} </h4>
                                </div>
                                <div class="form-group" v-else>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': submit && $v.address.$error }"
                                        placeholder="ที่อยู่ (ตามบัตรประชาชน)"
                                        v-model="address"
                                    />
                                    <!-- vuelidate -->
                                    <label
                                        class="error invalid-feedback"
                                        v-if="!$v.address.minLength"
                                    >กรุณากรอก"ที่อยู่"อย่างน้อย {{$v.address.$params.minLength.min}} ตัวอักษร</label>
                                    <label
                                        v-if="submit && !$v.address.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกที่อยู่</label>               
                                </div>
                            </div>
                             <div class="col-lg-6">
                                <label>ตำบล/แขวง : </label> 
                                <div v-if="isSuperadmin()">  
                                    <h4> {{state}} </h4>
                                </div>
                                <div v-else>
                                    <AutocompletesAddress
                                        :queryInput="state" 
                                        :adsTypes="'sub-district'"
                                        placeHolder="ตำบล/แขวง"
                                        :class="{ 'is-invalid': submit && $v.state.$error }"
                                        @input="state = $event.target.value"
                                        @select:item="onSubmitAddress( $event )">
                                    </AutocompletesAddress>
                                    <!-- vuelidate -->
                                    <div
                                        v-if="submit && !$v.state.required"
                                        class="invalid-th-address"
                                    >กรุณากรอกตำบล/แขวง</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <label>อำเภอ/เขต : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{district}} </h4>
                                </div>
                                <div v-else>
                                    <AutocompletesAddress
                                        :queryInput="district" 
                                        :adsTypes="'district'"
                                        placeHolder="อำเภอ/เขต"
                                        :class="{ 'is-invalid': submit && $v.district.$error }"
                                        @input="district = $event.target.value"
                                        @select:item="onSubmitAddress( $event )">
                                    </AutocompletesAddress>
                                    <!-- vuelidate -->
                                    <div
                                        v-if="submit && !$v.district.required"
                                        class="invalid-th-address"
                                    >กรุณากรอกอำเภอ/เขต</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <label>จังหวัด : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{province}} </h4>
                                </div>
                                <div v-else>
                                     <AutocompletesAddress
                                        :queryInput="province" 
                                        :adsTypes="'province'"
                                        placeHolder="จังหวัด"
                                        :class="{ 'is-invalid': submit && $v.province.$error }"
                                        @input="province = $event.target.value"
                                        @select:item="onSubmitAddress( $event )">
                                    </AutocompletesAddress>
                                    <!-- vuelidate -->
                                    <div
                                        v-if="submit && !$v.province.required"
                                        class="invalid-th-address"
                                    >กรุณากรอกจังหวัด</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <label>รหัสไปรษณีย์ : </label> 
                                <div v-if="isSuperadmin()">
                                    <h4> {{postcode}} </h4>
                                </div>
                                <div v-else>
                                    <AutocompletesAddress
                                        :queryInput="postcode" 
                                        :adsTypes="'postcode'"
                                        placeHolder="รหัสไปรษณีย์"
                                        :class="{ 'is-invalid': submit && $v.postcode.$error }"
                                        @input="postcode = $event.target.value"
                                        @select:item="onSubmitAddress( $event )">
                                    </AutocompletesAddress>
                                    <!-- vuelidate -->
                                    <div
                                        v-if="submit && !$v.postcode.required"
                                        class="invalid-th-address"
                                    >กรุณากรอกรหัสไปรษณีย์</div>
                                    <div
                                        class="error invalid-th-address"
                                        v-if="submit && !$v.postcode.minLength"
                                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.postcode.$params.minLength.min}} หลัก</div>
                                    <div
                                        class="error invalid-th-address"
                                        v-if="submit && !$v.postcode.maxLength"
                                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.postcode.$params.maxLength.max}} หลัก</div>
                                    <div
                                        class="error invalid-th-address"
                                        v-if="submit && !$v.postcode.numeric"
                                    >กรุณากรอกเฉพาะตัวเลข</div>
                                </div>
                            </div>
                        </div>
                        <template v-if="$USER_LOGIN.get().isShippop">
                            <hr class="my-4" />
                            <h6 class="heading-small text-muted mb-3">ข้อมูลคอมมิชชั่น</h6>
                            <div class="row">
                                <div class="col-lg-3" v-for="(item , index) in commission" :key="index">
                                    <h4 >{{courierName(item.key).name}} :</h4>
                                    <number-input
                                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189'"
                                        :step="0.1"
                                        v-model="item.commission"
                                        :min="0"
                                        :max="100"
                                        inline
                                        controls
                                        class="input-product-table"
                                    ></number-input>
                                    <label
                                        v-if="submit && !$v.commission.$each[index].commission.required"
                                        class="invalid-feedback"
                                    >กรุณากรอกค่าคอมมิชชั่น</label>
                                </div>
                            </div>
                        </template>
                        <hr class="my-4" />
                        <h6 class="heading-small text-muted mb-3">ข้อมูลบัญชีธนาคาร</h6>
                            <div class="row" v-if="isSuperadmin()">
                                <div class="col-lg-6">
                                    <label>ธนาคาร : </label> 
                                    <h4> {{bankName[0].name ? bankName[0].name : ''}} </h4>
                                </div>
                                <div class="col-lg-6">
                                    <label>ชื่อบัญชีธนาคาร : </label> 
                                    <h4> {{account[0].account_name}} </h4>
                                </div>
                                <div class="col-lg-6">
                                    <label>เลขที่บัญชี : </label> 
                                    <h4> {{account[0].account_id}} </h4>
                                </div>
                                <div class="col-lg-6">
                                    <label>สาขาธนาคาร : </label> 
                                    <h4> {{account[0].account_branch}} </h4>
                                </div>
                                <div class="col-lg-6">
                                    <label>รหัสสาขา : </label> 
                                    <h4> {{account[0].branch_code}} </h4>
                                </div>
                            </div>
                            <div class="row" v-else v-for="(acc, index) in account" :key="index">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>{{ (account.length > 1 ? ` ธนาคาร ${index+1}` : ' ธนาคาร')}}</label>
                                        <v-select 
                                            :class="[ { 'is-invalid bd-danger': submit && $v.account.$each[index].account_bank.$error } , 'w-100' ]"
                                            label="name"
                                            :options="bank"
                                            :key="acc.account_bank"
                                            v-model="acc.account_bank"
                                            :reduce="formatBank => formatBank.code"
                                        ></v-select>
                                        <!-- vuelidate -->
                                        <label
                                            v-if="submit && !$v.account.$each[index].account_bank.required"
                                            class="invalid-feedback d-block"
                                        >กรุณาเลือกธนาคาร</label>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>{{ (account.length > 1 ? ` ชื่อบัญชีธนาคาร ${index+1}` : ' ชื่อบัญชีธนาคาร')}} <small class="text-muted"> (ต้องตรงกับหน้าชื่อสมุดบัญชี)</small></label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': submit && $v.account.$each[index].account_name.$error }"
                                            placeholder="ชื่อบัญชีธนาคาร"
                                            v-model="acc.account_name"
                                        />
                                        <!-- vuelidate -->
                                        <label
                                            class="error invalid-feedback"
                                            v-if="!$v.account.$each[index].account_name.minLength"
                                        >กรุณากรอก"ชื่อบัญชีธนาคาร"อย่างน้อย {{$v.account.$each[index].account_name.$params.minLength.min}} ตัวอักษร</label>
                                        <label
                                            v-if="submit && !$v.account.$each[index].account_name.required"
                                            class="invalid-feedback"
                                        >กรุณากรอกชื่อบัญชีธนาคาร</label>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>{{ (account.length > 1 ? ` เลขที่บัญชี ${index+1}` : ' เลขที่บัญชี')}}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': submit && $v.account.$each[index].account_id.$error }"
                                            placeholder="เลขที่บัญชี"
                                            v-model="acc.account_id"
                                        />
                                        <!-- vuelidate -->
                                        <label
                                            class="error invalid-feedback"
                                            v-if="!$v.account.$each[index].account_id.minLength"
                                        >กรุณากรอก"เลขที่บัญชี"อย่างน้อย {{$v.account.$each[index].account_id.$params.minLength.min}} ตัวเลข</label>
                                        <label
                                            class="error invalid-feedback"
                                            v-if="!$v.account.$each[index].account_id.maxLength"
                                        >กรุณากรอก"เลขที่บัญชี"ไม่เกิน {{$v.account.$each[index].account_id.$params.maxLength.max}} ตัวเลข</label>
                                        <label
                                            v-if="submit && !$v.account.$each[index].account_id.required"
                                            class="invalid-feedback"
                                        >กรุณากรอกเลขที่บัญชี</label>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>{{ (account.length > 1 ? ` สาขาธนาคาร ${index+1}` : ' สาขาธนาคาร')}}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': submit && $v.account.$each[index].account_branch.$error }"
                                            placeholder="สาขาธนาคาร"
                                            v-model="acc.account_branch"
                                        />
                                        <!-- vuelidate -->
                                        <label
                                            v-if="submit && !$v.account.$each[index].account_branch.required"
                                            class="invalid-feedback"
                                        >กรุณากรอกสาขาธนาคาร</label>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                    <label>{{ (account.length > 1 ? ` รหัสสาขา ${index+1}` : ' รหัสสาขา')}}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': submit && $v.account.$each[index].branch_code.$error }"
                                            placeholder="รหัสสาขา"
                                            v-model="acc.branch_code"
                                        />
                                        <small class="text-muted">*ใช้สำหรับโอนเงิน (กรณีกรอกไม่ถูกต้อง ระบบจะไม่สามารถโอนเงินให้คุณได้)</small>
                                        <!-- vuelidate -->
                                        <label
                                            class="error invalid-feedback"
                                            v-if="!$v.account.$each[index].branch_code.minLength"
                                        >กรุณากรอก"รหัสสาขา"อย่างน้อย {{$v.account.$each[index].branch_code.$params.minLength.min}} ตัวเลข</label>
                                        <label
                                            class="error invalid-feedback"
                                            v-if="!$v.account.$each[index].branch_code.maxLength"
                                        >กรุณากรอก"รหัสสาขา"ไม่เกิน {{$v.account.$each[index].branch_code.$params.maxLength.max}} ตัวเลข</label>
                                        <label
                                            v-if="submit && !$v.account.$each[index].branch_code.required"
                                            class="invalid-feedback"
                                        >กรุณากรอกรหัสสาขา</label>
                                    </div>
                                </div>
                            </div>
                        <hr class="my-4" />
                        <h6 class="heading-small text-muted mb-3">ข้อมูลรูปภาพ</h6>
                            <div class="row" v-if="isSuperadmin() && customer_type == 'person' && customer_type == 'person' ">
                                <div class="col-lg-6 pb-3">
                                    <label>รูปภาพบัตรประชาชนด้านหน้า : </label> 
                                    <div class="text-center">
                                        <img class="image-hover py-2"
                                        :src="showImage.image_card_front" alt="image_card_front" width="250" height="200" @click="showModalImages(showImage.image_card_front , 'image_card_front')">
                                    </div>
                                </div>
                                <div class="col-lg-6 pb-3">
                                    <label>รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน : </label> 
                                    <div class="text-center">
                                        <img class="image-hover py-2"
                                        :src="showImage.image_card" alt="image_card" width="250" height="200" @click="showModalImages(showImage.image_card , 'image_card')">
                                    </div>
                                </div>
                                <div class="col-lg-6 pb-3">
                                    <label>รูปภาพสมุดบัญชี : </label> 
                                    <div class="text-center">
                                        <img class="image-hover py-2"
                                        :src="showImage.image_account" alt="image_account" width="250" height="200" @click="showModalImages(showImage.image_account , 'image_account')">
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="isSuperadmin() && customer_type == 'company' && customer_type == 'company' ">
                                <div class="col-lg-6 pb-3">
                                    <label>รูปภาพหนังสือรับรองบริษัท (หน้าแรก) : </label> 
                                    <div class="text-center">
                                        <img class="image-hover py-2"
                                        :src="showImage.image_company_certificate" alt="image_company_certificate" width="250" height="200" @click="showModalImages(showImage.image_company_certificate , 'image_company_certificate')">
                                    </div>
                                </div>
                                <div class="col-lg-6 pb-3">
                                    <label>รูปภาพภพ.20 (หน้าแรก ถ้ามี) : </label> 
                                    <div class="text-center">
                                        <img class="image-hover py-2"
                                        :src="showImage.image_certified_of_vat" alt="image_certified_of_vat" width="250" height="200" @click="showModalImages(showImage.image_certified_of_vat , 'image_certified_of_vat')">
                                    </div>
                                </div>
                                <div class="col-lg-6 pb-3">
                                    <label>รูปภาพสมุดบัญชีบริษัท (เป็นชื่อบริษัทเท่านั้น) : </label> 
                                    <div class="text-center">
                                        <img class="image-hover py-2"
                                        :src="showImage.image_business_account" alt="image_business_account" width="250" height="200" @click="showModalImages(showImage.image_business_account , 'image_business_account')">
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="isShippop()">
                                <div class="col-lg-6" v-for="(image,index) in images" :key="index">
                                    <div class="form-group">
                                        <label>
                                            {{image.lable}}
                                        </label>
                                        <b-form-file 
                                            :state="(submit && $v.images.$each[index].file.$error) ? false : null"
                                            accept=".jpg, .png"
                                            placeholder="เลือกรูปภาพ"
                                            @change="uploadImage(index,$event)"
                                            v-model="image.file"
                                        ></b-form-file>
                                        <div class="text-center pt-2" v-if="image.preview">
                                            <img class="image-hover py-2" :src="image.preview" alt="image_card_front" width="250" height="200" @click="showModalImages(image.preview , image.name)">
                                        </div>
                                        <label
                                            v-if="submit && !$v.images.$each[index].file.required"
                                            class="invalid-feedback"
                                        >กรุณาอัพโหลดรูปภาพ</label>
                                    </div>
                                </div>
                            </div>
                        <template>
                            <hr class="my-4" />
                            <h6 class="heading-small text-muted mb-3">ตรวจสอบข่้อมูลกรอกในระบบ (กรณีไม่อนุมัติ ระบบจะยังไม่คำนวณ Commission COD ให้กับลูกค้า)</h6>
                            <div class="row mb-2">
                                <div class="col-lg-12">
                                    <b-form-group>
                                        <b-form-radio-group
                                            v-model="status"
                                            :options="listApproveOnline"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                            </div>
                            <template v-if="!status">
                                <h6 class="heading-small text-muted mb-3">กรุณาเลือกเหตุผล (สามารถเลือกได้หลายข้อ)</h6>
                                <b-form-group>
                                    <b-form-checkbox
                                        v-for="rs in reason"
                                        v-model="selectedReason"
                                        class="col-lg-4 m-0 pb-4"
                                        :key="rs"
                                        :value="rs"
                                        inline
                                        @input="createRemark()"
                                    >
                                        {{ rs }}
                                    </b-form-checkbox>
                                </b-form-group>
                            </template>
                        </template>
                        <template name="document-offine" v-if="$USER_LOGIN.get().isShippop">
                            <hr class="my-4" />
                            <h6 class="heading-small text-muted mb-3">ตรวจสอบข้อมูลเอกสารตัวจริง (กรณีไม่อนุมัติเอกสารตัวจริง ระบบจะยังไม่จ่าย Commission COD ให้กับลูกค้า)</h6>
                            <div class="row">
                                <div class="col-lg-12">
                                    <b-form-group>
                                        <b-form-radio-group
                                            v-model="status_document"
                                            :options="listApproveOffline"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                            </div>
                            <template v-if="showInputRemark">
                                <h6 class="heading-small text-muted mb-3">กรุณาเลือกเหตุผล (สามารถเลือกได้หลายข้อ)</h6>
                                <b-form-group>
                                    <b-form-checkbox
                                        v-for="reason in reasonDocument"
                                        v-model="selectedReasonDocument"
                                        class="col-lg-4 m-0 pb-4"
                                        :key="reason"
                                        :value="reason"
                                        inline
                                        @input="createRemark()"
                                    >
                                        {{ reason }}
                                    </b-form-checkbox>
                                </b-form-group>
                            </template>
                            <div class="row" v-if="status_document">
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label>วันที่อนุมัติเอกสารจริง</label>
                                        <input 
                                            type="date" 
                                            class="form-control" 
                                            v-model="document_approved" 
                                            onkeydown="return false" 
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template name="remark" v-if="showInputRemark">
                            <hr class="my-4" />
                            <div class="row">
                                <div class="col-lg-12">
                                    <label>คำอธิบายเพิ่มเติม (ไม่บังคับ)</label>
                                    <textarea
                                        rows="3"
                                        class="form-control"
                                        placeholder="หมายเหตุ"
                                        v-model="remark"
                                        @input="createRemark()"
                                    ></textarea>
                                </div>
                                <div class="col-lg-12 my-2" v-if="isShippop()">
                                    <label>ตัวอย่างที่ลูกค้าจะเห็น</label>
                                    <h4 class="mx-1">{{remarkTotal}}</h4>
                                </div>
                            </div>
                        </template>
                            <hr class="my-4" />
                            <div class="row justify-content-end">
                                <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                                    <button
                                    type="button"
                                    class="btn btn-success btn-block btn-icon py-3"
                                    @click="statusChange()"
                                    >ยืนยัน</button>
                                </div>
                            </div>
                    </template>
                </card>
            </div>
        </div>
    </div>
    <ModalImages :data="dataModalImages" ></ModalImages>
  </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API;
import moment from 'moment'
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import validatePop from "../plugins/validatePop.js"
import ModalImages from '@/components/Modals/Modal-images'
import formatBank from "@/plugins/formatBank.js";
import { courierName } from "@/plugins/courierName.js";
import Compressor from 'compressorjs'
import {
  required,
  minLength,
  maxLength,
  numeric,
  email,
  decimal
} from "vuelidate/lib/validators";
export default {
    name:"dataverrify",
    components:{
        ModalImages,
        AutocompletesAddress
    },
    data(){
        return {
            listApproveOnline: [
                { text: 'อนุมัติ', value: true },
                { text: 'ไม่อนุมัติ', value: false },
            ],
            listApproveOffline: [
                { text: 'อนุมัติเอกสารตัวจริง', value: true },
                { text: 'ไม่อนุมัติเอกสารตัวจริง', value: false },
            ],
            userLogin:'',
            busy:false,
            submit: false,
            editImage: false,
            listStatus: [
                { code: false , statusTitle: 'ไม่ผ่าน' },
                { code: true , statusTitle: 'ผ่าน' }
            ],
            status:false ,
            selectedReason:[],
            selectedReasonDocument:[],
            reason:[
                'สมุดบัญชีไม่ตรงกับเอกสารจริง' ,
                'ไฟล์ภาพทั้งหมดไม่ชัดเจน' ,
                'ไฟล์ภาพบัตรประชาชนไม่ชัดเจน' ,
                'ไฟล์ภาพรูปถ่ายคู่บัตรไม่ชัดเจน' ,
                'ไฟล์ภาพสมุดบัญชีไม่ชัดเจน' ,
                'ไฟล์ภาพหนังสือรับรองไม่ชัดเจน' 
            ],
            reasonDocument:[
                 'กรอกข้อมูลไม่ครบ' ,
                 'ขาดสำเนาสมุดบัญชี' ,
                 'ขาดลายเซ็นและตราประทับ' ,
                 'ขาดสำเนาบัตรประชาชน' ,
                 'ขาดสำเนาทะเบียนบ้าน' ,
                 'ห้ามใช้กระดาษรียูส' 
            ],
            dateNow: moment().format("YYYY-MM-DD"),
            bank: formatBank,
            name_title: "",
            tax_id: "",
            laser_code: "",
            date_birthday: "",
            date_expiry: "",
            email: "",
            name: "",
            address: "",
            state: "",
            district: "",
            province: "",
            postcode: "",
            customer_type:"",
            status_document: false,
            document_approved: null,
            tel: "",
            file: "",
            account: [{}],
            showImage: {},
            remark: "",
            remarkTotal:"",
            commission: [],
            courierName: courierName,
            dataModalImages:{
                show:false,
                img:false,
                name:"img"
            },
            images:[
                {
                    name:'image_card_front',
                    lable:'รูปภาพบัตรประชาชนด้านหน้า',
                    file:null,
                    preview:"",
                },
                {
                    name:'image_card',
                    lable:'รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน', 
                    file:null,
                    preview:"", 
                },
                {
                    name:'image_account',
                    lable:'รูปภาพสมุดบัญชี',
                    file:null,
                    preview:"",
                },
            ],
        }
    },
    validations: {
        name_title: { required },
        name: { required, minLength: minLength(3) },
        address: { required, minLength: minLength(5) },
        state: { required },
        district: { required },
        province: { required },
        postcode: { required, numeric, minLength: minLength(4), maxLength: maxLength(5) },
        tel: { required, numeric, minLength: minLength(9) },
        tax_id: { required, minLength: minLength(13), maxLength: maxLength(13) },
        email: { required, email },
        date_birthday: { required },
        date_expiry: { required },
        account: {
          $each: {
            account_id: {
              required, 
              minLength: minLength(10), 
              maxLength: maxLength(15)
            },
            account_name: { 
              required, 
              minLength: minLength(3) 
            },
            account_branch: {
              required,
            },
            account_bank: {
              required,
            },
            branch_code: {
              required,
              minLength: minLength(3), 
              maxLength: maxLength(4)
            }
          }
        },
        images: {
            $each: {
                file: { required }
            }
        },
        commission: {
          $each: {
            commission: {
              required, 
            }
          }
        }
    },
    beforeMount(){
        this.userLogin = JSON.parse(localStorage.getItem("user"))
    },
    mounted(){
        this.getDataVerify()
    },
    methods:{
        createRemark(){
            this.remarkTotal = [...this.selectedReason , ...this.selectedReasonDocument].join(',');
            if(this.remark != ''){
                this.remarkTotal = [this.remarkTotal , this.remark].join(',');
            }
        },
        showModalImages( img , name ){
           this.dataModalImages.show = true
           this.dataModalImages.img = img
           this.dataModalImages.name = name
        },
        getDataVerify() {
            this.remarkTotal = '';
            this.busy = true
            this.$http
                .post(API_URL + "/shop/check/register/commisstion",{
                    user_id: this.$route.params.Id
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    let data = res.data.data
                    this.status_document = this.checkStatusDocument( data.document_approved )
                    this.name_title = data.name_title
                    this.tax_id = data.card_id
                    this.laser_code = data.laser_code
                    this.date_birthday = data.date_birthday
                    this.date_expiry = data.card_expire
                    this.email = data.email
                    this.name = data.name
                    this.address = data.address
                    this.state = data.state
                    this.district = data.district
                    this.province = data.province
                    this.postcode = data.postcode
                    this.customer_type = data.customer_type
                    this.tel = data.tel
                    if( data.remark ){
                        let remark = data.remark.split(",");

                        let remark_reason = remark.filter(x => this.reason.includes(x));
                        this.selectedReason = remark_reason

                        let remark_reasonDocument = remark.filter(x => this.reasonDocument.includes(x));
                        this.selectedReasonDocument = remark_reasonDocument
                        
                        let remark_difference = remark
                        .filter(x => ![...this.selectedReason , ...this.selectedReasonDocument].includes(x))
                        .concat([...this.selectedReason , ...this.selectedReasonDocument].filter(x => !remark.includes(x)));

                        this.remark = remark_difference.join(' ');
                    }
                    this.account = [{
                        'account_bank': data.account[0].account_bank,
                        'account_branch': data.account[0].account_branch,
                        'account_id': data.account[0].account_id,
                        'account_name': data.account[0].account_name,
                        'branch_code': data.account[0].branch_code
                    }]
                    if( this.$USER_LOGIN.get().isShippop ){

                        let date_of_doc = data.document_approved
                        if( date_of_doc == null || !date_of_doc ){

                            this.document_approved = moment().format( "YYYY-MM-DD" )

                        }else{

                            this.document_approved = moment( date_of_doc ).format( "YYYY-MM-DD" )
                        }                        

                        if( data.status > 0 ){

                            this.status = true

                        }

                        let image = Object.values(data.images)

                        if( this.customer_type == 'company' ){

                            this.images = [
                                {
                                    name:'image_company_certificate',
                                    lable:'รูปภาพหนังสือรับรองบริษัท (หน้าแรก)',
                                    file:null,
                                    preview:"",
                                },
                                {
                                    name:'image_certified_of_vat',
                                    lable:'รูปภาพภพ.20 (หน้าแรก ถ้ามี)',
                                    file:null,
                                    preview:"",
                                },
                                {
                                    name:'image_business_account',
                                    lable:'รูปภาพสมุดบัญชีบริษัท (เป็นชื่อบริษัทเท่านั้น)', 
                                    file:null,
                                    preview:"", 
                                },
                            ]
                        }

                        this.images.forEach((item , index) => {
                            if( this.customer_type == 'person' ){
                                item.preview = data.images[item.name]
                                item.file = item.name
                            }else{
                                this.images[index].preview = image[index]
                                this.images[index].file = this.images[index].name
                            }
                        })
                    
                    }else{
                        this.showImage = data.images
                    }
                    if( data.type == "superadmin" ){
                        this.commission = data.set_commission.superadmin
                    }else{
                        this.commission = data.set_commission.normal
                    }
                    this.handleLoader();
                });
        },
        checkStatusDocument( status ){

            let res = true
            if( status == null ){

                res = false

            }

            return res
        },
        statusChange() {
            if( this.isShippop() ){
                this.submit = true
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false
                }
            }
            this.busy = true
            this.$http
                .put(
                    API_URL + `/shop/status/register/commisstion/${this.$route.params.Id}`,
                    {
                        status: this.status,
                        status_document: this.status_document,
                        commission_rate: this.commission,
                        remark: this.remarkTotal,
                        ...( ( this.isShippop() ) ? { 
                            email: this.email,
                            laser_code: this.laser_code,
                            card_id: this.tax_id,
                            tel: this.tel,
                            account: this.account,
                            date_birthday: this.date_birthday,
                            document_approved: this.document_approved,
                            card_expire: this.date_expiry,
                            ...( ( typeof this.name_title == 'string' ) ? { name_title: this.name_title } : { name_title: this.name_title.nameTitle } ),
                            name: this.name,
                            address: this.address,
                            state: this.state,
                            district: this.district,
                            province: this.province,
                            postcode: this.postcode,   
                            customer_type: this.customer_type
                        } : {} ),
                        ...( ( this.editImage && this.customer_type == 'person' ) ? { images: JSON.stringify({
                                image_card_front: this.images[0].preview ,
                                image_card: this.images[1].preview,
                                image_account: this.images[2].preview
                            }),
                        } : ( this.editImage && this.customer_type == 'company' ) ? { images: JSON.stringify({
                                image_company_certificate: this.images[0].preview ,
                                image_certified_of_vat: this.images[1].preview,
                                image_business_account: this.images[2].preview,
                            }),
                        } : {} ),
                    },
                    {
                        headers: { Token: localStorage.getItem("access_token") }
                    }
                )
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.handleLoader();
                    this.modalSuccess("บันทึกข้อมูลสำเร็จ");

                });
        },
        uploadImage(index,e) {
            if (e.target.files.length < 1) return false;
            this.editImage = true
            const image = e.target.files[0]
            let SELF = this
            new Compressor(image, {
              quality: 0.6,
              maxHeight: 1024,
              maxHeight: 1024,
                success(result) {
                  const reader = new FileReader();
                  reader.readAsDataURL(result)
                  reader.onload = e => {
                    SELF.$set(SELF.images[index], 'preview' , e.target.result)
                  }
                }
            })
        },
        onSubmitAddress( ads ){
            Object.keys(ads).forEach( key =>{
                if( key == 'sub-district'){
                    this['state'] = ads['sub-district']
                }else{
                   this[key] = String(ads[key])
                }
            })
        },
        handleLoader(){
            this.busy = !this.busy
        },
        modalSuccess(msgBody) {
            this.$bvModal
                .msgBoxOk(msgBody, {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                })
                .then(value => {
                    this.getDataVerify()
                    // if (value) {
                    //     if(this.isSuperadmin()){
                    //         this.$router.push(`/confirmCommissionSPAdmin`)
                    //     }else{
                    //         this.$router.push(`/shop/commission`)
                    //     }
                    // }else{
                    //     window.location.reload();
                    // }
                });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "ERROR",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: OkmsgTitle,
            contentClass: "modal-errors",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
        isSuperadmin() {
            return this.userLogin.role === "superadmin";
        },
        isShippop() {
            return this.userLogin.role === "shippop";
        },
    },
    computed:{
        showInputRemark(){
            
            let res = false
            if( this.status == false || ( this.$USER_LOGIN.get().isShippop && !this.status_document ) ){

                res = true
            }else{
                this.remark = ""
            }
            return res
        },
        bankName(){
            let banks = [{name:'ไม่่พบชื่อธนาคาร'}]
            if( this.account[0].account_bank ){
                banks = formatBank.filter((bank) => {
                    return this.account[0].account_bank == bank.code
                })
            }
            
            return banks
        },
        ListNameTitle(){
            if( this.customer_type == 'person' ){
                return  [
                    { code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
                    { code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
                    { code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'}
                ]
            }else{
                return  [
                    { code: 4 , nameTitle: 'บจก.' , nameTitleEng: 'MR'},
                    { code: 5 , nameTitle: 'บริษัท' , nameTitleEng: 'MR'},
                    { code: 6 , nameTitle: 'ห้างหุ้นส่วนจำกัด' , nameTitleEng: 'MR'},
                ]
            }
        }
    }
}
</script>

<style scoped>
.image-hover{
border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}
.image-hover:hover {opacity: 0.7;}

</style>